import type { EnvironmentProviders, Provider } from '@angular/core';
import { MinimalProviders } from '@app/minimal-providers';

/**
 * Retrieves the array of providers for the application module.
 * The providers include a combination of minimal required providers
 * and environment-specific providers.
 *
 * @returns {Array<Provider | EnvironmentProviders>} An array of providers containing
 * minimal and environmental configurations for the application module.
 */
export function getAppModuleProviders(): (Provider | EnvironmentProviders)[] {
  return [...MinimalProviders];
}
